import Loading from "../../utils/Loading"; //获取加载组件
import { WebsiteUrl } from "../../utils";

export default {
	name: 'ModuleBox',
	components: {

	},
	data(){
		return{
			LogoUrl:WebsiteUrl()+'/images/ModuleBoxBodyBodyLogo.png',

		}
	},
	methods:{





	},
	mounted(){

	}
}

